import { render } from "./CentreCheque.vue?vue&type=template&id=60f1b4f8&scoped=true&ts=true"
import script from "./CentreCheque.vue?vue&type=script&lang=ts"
export * from "./CentreCheque.vue?vue&type=script&lang=ts"

import "./CentreCheque.vue?vue&type=style&index=0&id=60f1b4f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f1b4f8"]])

export default __exports__